import React, { useContext, useReducer } from "react";
import axios from "axios";
import StatusLogContext from "./StatusLogContext";
import StatusLogReducer from "./StatusLogReducer";
import {
  GET_FB_STATUS_LOG,
  GET_FB_ALERT,
  FB_STATUS_LOG_ERROR,
} from "../../types";

// Contexts
import LayoutContext from "../../layout/LayoutContext";

const StatusLogState = (props) => {
  const initialState = {
    status_logs: null,
    facebook_alerts: null,
    error: null,
  };

  const [state, dispatch] = useReducer(StatusLogReducer, initialState);
  const { setLoading, setAlert } = useContext(LayoutContext);

  const getStatusLogs = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/facebook_profile/facebook-status");

      dispatch({
        type: GET_FB_STATUS_LOG,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: FB_STATUS_LOG_ERROR,
        payload: err.response,
      });
    }
    setLoading(false);
  };

  const getFacebookAlert = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/facebook_profile/facebook-alert");

      dispatch({
        type: GET_FB_ALERT,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: FB_STATUS_LOG_ERROR,
        payload: err.response,
      });
    }
    setLoading(false);
  };

  return (
    <StatusLogContext.Provider
      value={{
        status_logs: state.status_logs,
        facebook_alerts: state.facebook_alerts,
        error: state.error,
        getStatusLogs,
        getFacebookAlert,
      }}
    >
      {props.children}{" "}
    </StatusLogContext.Provider>
  );
};

export default StatusLogState;
